import React, { Fragment } from "react";
import { Card, Col, Row } from 'react-bootstrap';
import '../../../../styles/diario.scss'

const Remume = (props) => {

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header><h5>{props.remume.nome}</h5></Card.Header>
                    <Card.Body>
                    <p>Concentração/Composição: {props.remume.composicao}</p>
                    <p>Apresentação: {props.remume.apresentacao}</p>
                    <p>Disponibilidade: {props.remume.disponibilidade}</p>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Remume;